import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("el-GR", { day: "numeric", month: "short", year: "numeric" });

export const BlogCard = ({ post, featured = false }) => (
  <Link
    to={`/blog/${post.slug}`}
    data-testid={`blog-card-${post.slug}`}
    className={`pcb-card group overflow-hidden flex flex-col ${featured ? "lg:col-span-2 lg:flex-row" : ""}`}
  >
    <div className={`relative overflow-hidden ${featured ? "lg:w-1/2 aspect-[16/10] lg:aspect-auto" : "aspect-[16/10]"}`}>
      <img
        src={post.image}
        alt={post.title}
        loading="lazy"
        decoding="async"
        width="1264"
        height="848"
        className="w-full h-full object-cover img-hover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#04101c] via-transparent to-transparent" />
      <span className="absolute top-3 left-3 text-[11px] uppercase tracking-wider px-2.5 py-1 rounded-md bg-emerald-500/20 border border-emerald-400/40 text-emerald-200 backdrop-blur">
        {post.category_label}
      </span>
    </div>
    <div className={`p-5 flex flex-col flex-1 ${featured ? "lg:p-8 lg:justify-center" : ""}`}>
      <div className="flex items-center gap-3 text-xs text-emerald-200/60">
        <span>{formatDate(post.created_at)}</span>
        <span className="inline-flex items-center gap-1">
          <Clock className="w-3.5 h-3.5" /> {post.read_minutes} λεπτά
        </span>
      </div>
      <h3 className={`mt-2 font-bold text-white leading-snug group-hover:text-emerald-300 transition-colors ${featured ? "text-2xl lg:text-3xl" : "text-lg"}`}>
        {post.title}
      </h3>
      <p className="mt-2 text-sm text-emerald-50/70 leading-relaxed line-clamp-3">{post.excerpt}</p>
      <span className="mt-4 inline-flex items-center gap-1 text-sm text-emerald-300 font-medium">
        Διαβάστε περισσότερα <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </div>
  </Link>
);
